up.compiler('.open-in-modal:has([disabled])', (element, data) => {
  return [
    up.on(element, 'click', () => { up.navigate({ url: data.url, layer: 'new', history: false }) }),
  ]
})
